import React from "react";
import { Link } from "react-router-dom";
import useRewriteUrl from "../../hooks/useRewriteUrl";
const ButtonAddTraceability = (props) => {
  useRewriteUrl();
  return (
    <div>
      <Link className="traceability-add-button" to="/chuyen-muc/truy-xuat-nguon-goc/tao-moi">
        <span style={{ fontSize: "50px", color: "#fff", marginBottom: "10px" }}>+</span>
      </Link>
    </div>
  );
};
export default ButtonAddTraceability;
